import { FrameItem, Icon, Input, MessageBox, TitleField } from 'components';
import { useSpot } from 'hooks';
import { useEffect, useRef, useState } from 'react';
import { Button, Form } from 'react-bootstrap';
import { useParams } from 'react-router-dom';
import { getProfileUser } from 'utils';
import './SpotDetailUsersComment.scss';
import { STATUS_API } from 'uniforms';

type Props = {};

const SpotDetailUsersComment = (props: Props) => {
    const { getSpotComment, postSpotComment, deleteComment } = useSpot();
    const { id } = useParams();
    const inputRef = useRef<any>();
    const userInfo = getProfileUser();
    const [listComment, setListComment] = useState<any>([]);

    const handleSubmitComment = (e: React.FormEvent<HTMLFormElement>): void => {
        e.preventDefault();
        let comment = inputRef.current.value.trim();
        if (comment != '') {
            inputRef.current.value = '';
            postSpotComment({
                spot_id: Number(id),
                comment_content: comment,
                successCallback(data) {
                    if (data?.error_code === STATUS_API.SUCCESS) {
                        let commentData = data?.result_records?.comment_detail;
                        setListComment([
                            ...listComment,
                            {
                                comment_sub_id: commentData?.comment_sub_id,
                                comment_content: comment,
                                created_at: commentData?.created_at,
                                ...userInfo,
                            },
                        ]);
                    }
                },
                failureCallback(data) {},
            });
        }
    };

    const handleDeleteComment = (commentId: string) => {
        deleteComment({
            spot_id: Number(id),
            comment_sub_id: commentId,
            successCallback(data) {
                if (data.error_code === STATUS_API.SUCCESS) {
                    setListComment(prev => prev.filter(item => item.comment_sub_id !== commentId));
                }
            },
            failureCallback(data) {},
        });
    };
    useEffect(() => {
        getSpotComment({
            spot_id: Number(id),
            successCallback(data) {
                if (
                    data &&
                    data?.result_records &&
                    data?.result_records.spot_comment_list &&
                    data?.result_records.spot_comment_list.length > 0 &&
                    data?.error_code === STATUS_API.SUCCESS
                ) {
                    setListComment(data?.result_records?.spot_comment_list);
                }
            },
            failureCallback(data) {},
        });
    }, [id]);

    return (
        <div className="mt-10">
            <FrameItem
                children={
                    <div className="spotdetail-users-comment">
                        <div className="title">
                            <span className="icon">
                                <Icon.Chat />
                            </span>
                            <div className="text-icon">みんなからのコメント</div>
                        </div>
                        <div>
                            <Form className="input-comment-container mt-3" onSubmit={handleSubmitComment}>
                                <Input
                                    type="text"
                                    name="spot_title"
                                    onBlur={() => {}}
                                    placeholder="コメントを投稿する"
                                    ref={inputRef}
                                    noControlled={true}
                                    noControlledButton={
                                        <Button className="post-btn" type="submit">
                                            投稿
                                        </Button>
                                    }
                                />
                            </Form>
                        </div>
                        {/* <div className="list-users-comment">
                            {listComment.length > 0 &&
                                listComment
                                    .slice(0)
                                    .reverse()
                                    .map((item, index) => {
                                        let enableDelete = false;
                                        if (item?.cognito_user_id === userInfo?.cognito_user_id) {
                                            enableDelete = true;
                                        }
                                        return (
                                            <div className="user-comment" key={index}>
                                                <MessageBox
                                                    handleDeleteComment={handleDeleteComment}
                                                    enableDelete={enableDelete}
                                                    key={index}
                                                    spotComment={item}
                                                />
                                            </div>
                                        );
                                    })}
                        </div> */}
                    </div>
                }
            />
        </div>
    );
};

export default SpotDetailUsersComment;
